"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LexiWallet = void 0;
const encryption_key_box_1 = __importDefault(require("../lib/encryption_key_box"));
const encrypt_1 = require("../lib/encrypt");
const key_1 = require("../lib/key");
const wallet_1 = require("../lib/wallet");
const util_1 = require("../lib/util");
class LexiWallet {
    constructor(wallet, myDID, options = {}) {
        this.wallet = new wallet_1.CachedSignWallet(wallet);
        this.myDID = myDID;
        this.options = options;
        this.singleUsePublicString =
            options.publicSigningString || (0, key_1.generateRandomString)();
        this.encryptionKeyBoxes = {};
    }
    getEncryptionKeyBox(signingString) {
        const key = signingString || this.singleUsePublicString;
        const value = this.encryptionKeyBoxes[key] || new encryption_key_box_1.default();
        this.encryptionKeyBoxes[key] = value;
        return value;
    }
    // get the key box for our own signer but also make sure it contains a hydrated key pair
    async getHydratedEncryptionKeyBox(signingString) {
        const keyBox = this.getEncryptionKeyBox(signingString);
        await (0, util_1.hydrateEncryptionKeyBox)(keyBox, signingString, this.wallet);
        return keyBox;
    }
    async generateKeyForSigning() {
        return (0, key_1.generateX25519KeyPairFromSignature)(this.wallet, this.singleUsePublicString, this.getEncryptionKeyBox());
    }
    decrypt(cyphertext) {
        return (0, encrypt_1.decryptJWEWithLexi)(cyphertext, this.wallet, this.getEncryptionKeyBox(cyphertext.signingString));
    }
    encrypt(plaintext, did) {
        return (0, encrypt_1.encryptForDid)(plaintext, did, this.options.resolve);
    }
    encryptForMe(plaintext) {
        return (0, encrypt_1.encryptForMe)(plaintext, this.myDID, this.wallet, this.singleUsePublicString, this.getEncryptionKeyBox(), this.options.resolve);
    }
    async decryptCEK(encryptionPackage) {
        let encryptionKeyBox = await this.getHydratedEncryptionKeyBox(encryptionPackage.signingString);
        return (0, encrypt_1.decryptCEK)(encryptionPackage, encryptionKeyBox);
    }
    signMessage(message) {
        return this.wallet.signMessage(message);
    }
}
exports.LexiWallet = LexiWallet;
